import React from 'react';
import { createRoot } from 'react-dom/client';

import StaffModal from './app/StaffModal';

// Progressively enhance "See Bio" buttons that carry bio content (modal trigger).
// Buttons with a bioUrl are plain <a> tags rendered by PHP and need no enhancement.
document.querySelectorAll('.see-bio-button[data-bio-content]').forEach((button) => {
  button.addEventListener('click', () => {
    if (document.querySelector('.leadership-cards-modal')) {
      return;
    }

    const member = {
      bioContent: button.dataset.bioContent || '',
      imageAlt: button.dataset.imageAlt || '',
      imageUrl: button.dataset.imageUrl || '',
      modalTitle: button.dataset.modalTitle || '',
      name: button.dataset.name || '',
      staffSubhead: button.dataset.staffSubhead || '',
      title: button.dataset.title || '',
    };

    const mountNode = document.createElement('div');
    document.body.appendChild(mountNode);
    const root = createRoot(mountNode);

    const handleClose = () => {
      root.unmount();
      document.body.removeChild(mountNode);
    };

    root.render(<StaffModal member={member} onClose={handleClose} />);
  });
});
